import 'css-chunk:src/components/widgets/ContentPreviewer/Content/YouTubeContent.scss';export default {
  "YouTubeContent": "_YouTubeContent_11vwv_1",
  "image": "_image_11vwv_4"
};